import {FC, useState, createContext, useContext} from 'react'
import {
    QueryState,
    QueryRequestContextProps,
    initialQueryRequest,
    WithChildren,
} from '../../../../../_metronic/helpers'

const DLMDOCQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMDOCQueryRequestProvider: FC<WithChildren> = ({children}) => {
    const [state, setState] = useState<QueryState>(initialQueryRequest.state)

    const updateState = (updates: Partial<QueryState>) => {
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return (
    <DLMDOCQueryRequestContext.Provider value={{state, updateState}}>
        {children}
    </DLMDOCQueryRequestContext.Provider>
    )
}

const useDLMDOCQueryRequest = () => useContext(DLMDOCQueryRequestContext)
export {DLMDOCQueryRequestProvider, useDLMDOCQueryRequest}
